import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { HeartHandshake } from "lucide-react";
import api from "../lib/api";
import { IconRenderer } from "../lib/icons";

export default function SharedRoutine() {
  const { token } = useParams();
  const [routine, setRoutine] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/share/${token}`)
      .then((r) => setRoutine(r.data))
      .catch(() => setError(true));
  }, [token]);

  return (
    <div data-testid="shared-routine-page" className="min-h-screen bg-background">
      <header className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-2">
        <span className="w-10 h-10 rounded-2xl bg-primary grid place-items-center">
          <HeartHandshake size={24} strokeWidth={2.5} className="text-white" />
        </span>
        <span className="text-xl font-extrabold tracking-tight">RoutineBuddy</span>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8 pb-24">
        {error ? (
          <p data-testid="shared-error" className="bg-white rounded-3xl border-2 border-foreground/10 p-8 text-lg text-muted-foreground">
            This shared routine link has expired or is invalid.
          </p>
        ) : !routine ? (
          <p className="text-lg text-muted-foreground">Loading…</p>
        ) : (
          <>
            <h1 data-testid="shared-routine-name" className="text-3xl sm:text-4xl font-extrabold tracking-tight flex items-center gap-3">
              <IconRenderer name={routine.icon} size={40} className="text-primary" /> {routine.name}
            </h1>
            <p className="mt-2 text-lg text-muted-foreground">A routine shared with you from RoutineBuddy.</p>
            <div className="mt-6 space-y-4">
              {routine.steps.map((s, i) => (
                <div key={i} data-testid={`shared-step-${i}`} className="bg-white rounded-3xl border-2 border-foreground/15 p-5 flex items-center gap-5">
                  <span className="w-16 h-16 rounded-2xl bg-primary/10 grid place-items-center shrink-0">
                    <IconRenderer name={s.icon} size={32} className="text-primary" />
                  </span>
                  <span>
                    <span className="block text-sm font-bold text-muted-foreground">Step {i + 1}</span>
                    <span className="block text-2xl font-extrabold">{s.label}</span>
                  </span>
                </div>
              ))}
            </div>
            <Link to="/" data-testid="shared-cta" className="mt-8 w-full min-h-[64px] rounded-full bg-primary text-white text-xl font-bold flex items-center justify-center transition-transform duration-200 ease-out hover:-translate-y-px">
              Make your own routines — free
            </Link>
          </>
        )}
      </main>
    </div>
  );
}
